import { setData, openModal, closeModal } from "store/modal.slice";
import { ModalType } from "parts/modal/modal";

const modalUtil = {
  show: (
    data: ModalType,
    dispatch: (arg0: {
      payload: any;
      type: "modal/setData" | "modal/openModal" | "modal/closeModal";
    }) => void
  ) => {
    dispatch(setData(data));
    dispatch(openModal());

    if (data.autoClose) setTimeout(() => dispatch(closeModal()), 5000);
  },
};

export const sanitizeId = (str: string) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()
    .replace(/[^a-z0-9-_]/g, '');
};

export default modalUtil;
